import { Component } from "@angular/core";

@Component({
  selector: "app-authenticating-screen",
  imports: [],
  template: `
    <div class="authenticating-screen">
      <p class="subtitle-1">Exercice en préparation...</p>
    </div>
  `,
  styles: `
    .authenticating-screen {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
      height: calc(100vh - 52px);
    }
  `,
})
export class AuthenticatingScreen {}
